import styled from 'styled-components'
import { AsyncPaginate } from 'react-select-async-paginate'

// Reused from Therapy subsection
export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 8px 12px;
  align-items: start;
  margin-top: 8px;
`

export const Label = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7280;
  padding-top: 8px;
`

export const StyledTextarea = styled.textarea`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font: inherit;
  min-height: 80px;
  resize: vertical;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: #c4b5fd;
  }
`

export const StyledSelect = styled.select`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font: inherit;
  background: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #c4b5fd;
  }
`

export const MutedText = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
`

// New components for HYBRID multi-select
export const HybridSelectContainer = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  background: white;
`

export const StaticOptionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px;
  margin-bottom: 12px;
`

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: background 0.15s;

  &:hover {
    background: #f8fafc;
  }

  input[type='checkbox'] {
    cursor: pointer;
  }
`

export const SearchableSection = styled.div`
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
  margin-top: 8px;
`

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font: inherit;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: #c4b5fd;
  }
`

export const SearchResultsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`

export const SearchPill = styled.button`
  border: 1px solid #e5e7eb;
  background: white;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #f8fafc;
    border-color: #c4b5fd;
  }

  &:active {
    background: #f1f5f9;
  }
`

export const SelectedPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #ede9fe;
  color: #6b21a8;
  border-radius: 12px;
  font-size: 12px;
  margin-right: 6px;
  margin-bottom: 6px;
`

export const RemovePillButton = styled.button`
  background: none;
  border: none;
  color: #6b21a8;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  font-size: 14px;

  &:hover {
    color: #581c87;
  }
`

export const StyledAsyncSelect = styled(AsyncPaginate)`
  /* Override react-select styles to match custom UI */

  .react-select__control {
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 0px 2px;
    min-height: unset;
    box-shadow: none;

    &:hover {
      border-color: #e5e7eb;
    }

    &--is-focused {
      border-color: #c4b5fd;
      box-shadow: none;
    }
  }

  .react-select__value-container {
    padding: 2px 8px;
  }

  .react-select__input-container {
    margin: 0;
    padding: 0;
  }

  .react-select__placeholder {
    color: #9ca3af;
  }

  .react-select__menu {
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
  }

  .react-select__option {
    padding: 8px 12px;

    &--is-focused {
      background: #f8fafc;
    }

    &--is-selected {
      background: #c4b5fd;
      color: white;
    }
  }
`
